export interface IOrderStatusIconProps {
  orderStatus?: string;
  received?: boolean;
}

function OrderStatusIcon({ orderStatus, received }: IOrderStatusIconProps ) {
  if (orderStatus === undefined) return "";
  if (received) return "";
  switch (orderStatus) {
    case "Completed":
      return "✅ ";
    case "Planning":
      return "🔄⚠️ ";
    case "Awaiting delivery":
      return "🚚 ";
    case "Canceled":
      return "❌ ";
    default:
      return `❔ ${orderStatus} `;
  }
}

export default OrderStatusIcon;
